import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/seoAuditData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const SeoAudit = () => {
  useMetaTags({
    title: "SEO Audit Services | Complete Website SEO Audit & Action Plan",
    description:
      "SEO audit services that uncover issues and opportunities. Warrgyizmorsch delivers a complete SEO audit and clear action plan to improve rankings and site performance.",
    keywords:
      "seo audit, seo audit services, site seo audit, seo tech audit, seo technical audit, seo audit reports, on page seo audit, seo audit website, seo audit online, seo web site audit",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h2 className="sec-title text-white">
                Achieve SEO Audit Excellence: Full Website Audit & Optimization
                Plan
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/seoAuditimage.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  We know that SEO is a key element in the growth of your
                  business. We have put together an in-depth website audit and
                  optimization plan which we present to you to see better
                  rankings, more traffic, and in turn more revenue. We bring to
                  the table the expertise that will make your site fully
                  optimized for the current SEO trends. From on-page SEO audit
                  to technical issues and from developing strategies to that
                  which will set us apart from the rest, we give you the info
                  and recommendations that will put you above your competition
                  and grow your online presence.
                </p>
              </div>
            </div>
            {/* What’s Included in Our Comprehensive SEO Audit Services?  */}
            <Handle_Largedata_section LargeData={LargeData} />

            {/* SEO Audit to Help You Surpass the Competition  */}
            <Role_writing data={roleWriting} />

            {/* SEO Expert Audits to Boost Your Business Revenue  */}
            <Boost_section data={BoostSection} />

            {/* SEO Audit Checklist: Common Issues We Assess  */}
            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default SeoAudit;
